import AppNavigator from './AppNavigator';
import { useAuth } from './context/AuthContext';
import AuthNavigator, { AuthLayout, FooterAuth, HeaderAuth } from './AuthNavigator';
import { useEffect } from 'react';
import { DaysProvider } from './context/DaysContext';
import { createBrowserRouter, Link, Navigate, Outlet, Route, RouteObject, RouterProvider, Routes, useRoutes } from 'react-router-dom';
import DeleteAccount from './shared/DeleteAccount';
import { AppLoadingProvider, useAppLoading } from './context/AppLoadingContext';
import { StatsProviderV2 } from './context/StatsContextV2';
import Goals from './pages/Goals/Goals';
import Stats from './pages/Stats/Stats';
import Friends from './pages/Friends/Friends';
import Settings from './pages/Settings/Settings';
import User from './pages/User/User';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import LandingPage from './auth/LandingPage';
import DownloadPage from './auth/DownloadPage';
import Login from './auth/Login';
import Register from './auth/Register/Register';
import Verify from './auth/Verify';
import ResetPassword from './auth/ResetPassword';
import VerifyResetPassword from './auth/VerifyResetPassword';
import Header from './components/Header';
import Pop from './components/Pop/Pop';
import Footer from './components/Footer';
import Loader from './components/Loader/Loader';
import { NotificationProvider } from './pages/Settings/Notifications/Notifications';
import { ProgressProvider } from './context/ProgressesContext';
import Support from './auth/Support';
import TermsOfUse from './pages/TermsOfUse/TermsOfUse';
import { Capacitor } from '@capacitor/core';
import { InitializeOptions, SocialLogin } from '@capgo/capacitor-social-login';
import { baseUrl } from './constants';
import { initPushNotifications } from './utils/pushNotifications';

const LoadingLayer = () =>{
    const {loading} = useAppLoading();
    return <div style={{position: "fixed", width: "100%", height: "100%", overflow: "hidden", zIndex: 1000, backgroundColor: "rgba(0,0,0,0.5)", display: loading? "none": "none"}}>
        <Loader size={50}/>
    </div>
}
const AppLayout = () => {
    const {user} = useAuth();
    useEffect(()=>{
        console.log("app navigator", Capacitor.getPlatform());
        if(Capacitor.getPlatform() == "ios" || Capacitor.getPlatform() == "android"){
            initPushNotifications();
        }
    },[])
    if(! user) return <div> invalid</div>

    return (
        <AppLoadingProvider>
            <NotificationProvider>
                <DaysProvider>
                    <ProgressProvider>
                    <StatsProviderV2 user={user}>
                       <Header></Header>
         <LoadingLayer />
         <Pop />

        
                
         <div id='page'>
            
            <div className='page-content'>
                <Outlet />
            </div>
         </div>
         <Footer></Footer> 
                    </StatsProviderV2>
                    </ProgressProvider>
              </DaysProvider>
              </NotificationProvider>
            </AppLoadingProvider>
    )
}
const appRoutes: RouteObject[] = [{
        index: true,
        path: "/*",
        element: <Goals />
    },{
        path: "/stats",
        element: <Stats />
    },{
        path: "/friends",
        element: <Friends />
    },{
        path: "/settings",
        element: <Settings />
    },{
        path: "/user/:userId",
        element: <User />
    },
    ];
    console.log(Capacitor.getPlatform());
const authRoutes: RouteObject[] = [{

    index: true,
    path: "/home",
    element:  Capacitor.getPlatform() == "web" ? <LandingPage /> : <Register />

},
{
    path: "/download",
    element: <DownloadPage />
},
{
    
    path: "/login",
    element: <Login />
}, {
    path: "/register",
    element: <Register/>
},{
    path: "/reset-password",
    element: <ResetPassword />
},{
    path: "/verify-password/:userId/:token",
    element: <VerifyResetPassword />
},   
{
    path: "/delete-account/:id/:token",
    element: <DeleteAccount />
}
]
const sharedRoutes: RouteObject[] = [
{
    path: "/support",
    element: <Support />
},{
    path: "/terms-of-service",
    element: <TermsOfUse />
},{
    path: "/privacy-policy",
    element: <PrivacyPolicy />
},
]
const SharedLayout = () =>{
    const {logged, user} = useAuth();
    return (
        <>
        {logged && user? <Header></Header> : <HeaderAuth />}
        <Outlet />
         {logged && user? <Footer />: <FooterAuth />}
        </>
    )
}
const SharedRoutes = () =>{
    const {logged, user} = useAuth();
    return 
}
const AppRoutes = () =>{
    const {logged, user} = useAuth();
    if(logged && user) return <AppLayout />
    return <Navigate to={"/home"} />

}
const appRouter = createBrowserRouter([{
    element: <AppRoutes />,
    children: appRoutes,
},{
    element: <AuthLayout />,
    children: authRoutes
},{
    path: "/verify/:userId/:token",
    element: <Verify />
},{
    children: sharedRoutes,
    element: <SharedLayout />
}]);

const loader = document.getElementById("app-loader");

export const removeLoader = () =>{
    if(!loader) return;
    loader.style.display = "none"
}
export const setLoader = () =>{
    if(!loader) return;
    loader.style.display = "flex"
}
const iosClientId = '487547214-9vuupcbd3o4ieahtk4h4t6497r2upjdo.apps.googleusercontent.com' ;
const webClientId = '487547214-baefeuraqc1qj8f1lt89slhc8tudn5s4.apps.googleusercontent.com';
const NavigatorV2 = () =>{
    const {logged, user, loading} = useAuth();
    const initializeOptions: InitializeOptions = Capacitor.getPlatform() == "ios"? {
        google: {
          iOSClientId: iosClientId,
          mode: "online"
        },
        apple: {
            //   clientId: "com.goalapp.it.app",
            //   redirectUrl: baseUrl + "/login-with-apple",
            }
          
      }: {
        google: {
          webClientId: webClientId,
        },
        apple: {
            //   clientId: "com.goalapp.it.app",
            //   redirectUrl: baseUrl + "/login-with-apple",
            }
      }
      useEffect(()=>{
        console.log("Initializing social login with options", initializeOptions);
        
        
        SocialLogin.initialize(initializeOptions);
      },[]);
    useEffect(()=>{

        
        //-- console.log("navigator",{logged, user, loading})
    }, [logged, user, loading])
    useEffect(() =>{
        if(!loader) return
        if(loading) setLoader()
        else if(!loading) removeLoader()

    },[loading])
    if(loading) return null;
    return <RouterProvider router={appRouter} />
//    if(loading) return null;
//     //-- console.log("not loading", {user, logged, loading, url: window.location.href})
//     return (
//         <>
//         {logged && user? 
//             <AppLoadingProvider>
//                 <DaysProvider>
//                     <StatsProviderV2 user={user}>
//                         <AppNavigator  />
//                     </StatsProviderV2>
//                 </DaysProvider>
//             </AppLoadingProvider>
//         : <AuthNavigator/>}

//         </>
// )
    
}
export default NavigatorV2